export const ROUTES = {
  dashboard: "/",
  dashboardV2: "/dashboard-v2",
  places: "/places",
  storages: "/storages",
  anomalies: "/anomalies",
  usage: "/usage",
  usageReport: "/usage-report",
  usageSettings: "/usage-settings",
  centralConfiguration: "/central-configuration",
  status: "/status",
  storage: "/storages/:id",
  editStorage: "/storages/:id/edit",
  newStorage: "/storages/new",
  clients: "/clients",
  client: "/clients/:id",
  editClient: "/clients/:id/edit",
  newClient: "/clients/new",
  orders: "/orders",
  contracts: "/contracts",
  newContract: "/contracts/new",
  editContract: "/contracts/:id/edit",
  services: "/services",
  billing: "/billing",
  members: "/members",
  notifications: "/notifications",
  settings: "/settings",
  login: "/login",
  member: "/members/:id",
  invoice: "/billing/:id",
  service: "/services/:id",
  driverLicenses: "/driver-licenses",
  driverLicense: "/driver-licenses/:id",
  carRentalCosts: "/car-rental-costs",
  reports: "/reports",
  supportTickets: "/support-tickets",
  supportTicket: "/support-tickets/:id",
  supportTicketTypes: "/support-ticket-types",
  supportTicketType: "/support-ticket-types/:id",
  evChargers: "/ev-chargers",
  evCharger: "/ev-chargers/:id",
  evTransactions: "/ev-transactions",
  heatPumps: "/heat-pumps",
  heatPump: "/heat-pumps/:id",
};

export const NEW_KEY = "new";
